export default "__VITE_ASSET__BEvMftSa__ 640w, __VITE_ASSET__CHIYTpb9__ 1024w";